<template>
	<header id="top-nav">
		<Sm-Nav-Bar />
		<Lg-Nav-Bar />
	</header>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import SmNavBar from './SmNavBar.vue';
import LgNavBar from './LgNavBar.vue';

export default {
	name: 'TopNavBar',
	components: {
		SmNavBar,
		LgNavBar,
	},
	computed: mapState({
		expandedMenu: (state) => state.menus.expandedMenu,
		expandedSmallNav: (state) => state.menus.expandedSmallNav,
	}),
};
</script>

<style lang="scss">
.b360-hamburger-menu-icon,
.b360-small-search-icon {
	padding: 5px 10px;
	border: $b360-border-width-thin solid $border-color-light;
	border-radius: $b360-border-radius-large;
	cursor: pointer;
	color: $brand-blue;
	@include rem(font-size, 18px);
	user-select: none;
	background-color: $white;
}

.b360_menu_icon_inverse {
	color: $off-white;
	background-color: $brand-blue;
}

.expanded {
	@include lg {
		width: $expanded-menu-width !important;
	}

	@include sm {
		display: none;
	}
}

#top-nav {
	position: fixed;
	top: 0;
	left: 0;
	height: $top-nav-height;
	width: 100%;
	z-index: 13;
	border-bottom: $border-width solid $border-color-light;
	display: flex;
	align-items: center;
	background-color: $white;
}

.lg-top-nav {
	@include sm {
		display: none;
	}
}
</style>
